import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useEnquiries from "./useEnquiries";

const Enquiries = () => {
  const { drawerMenu } = useEnquiries();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Enquiries;
